"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var composeHandlers = function composeHandlers() {
  for (var _len = arguments.length, errorHandlersFn = new Array(_len), _key = 0; _key < _len; _key++) {
    errorHandlersFn[_key] = arguments[_key];
  }

  return function (response) {
    return _rxjs.of.apply(void 0, errorHandlersFn).pipe((0, _operators.mergeMap)(function (handler) {
      return handler(response);
    }));
  };
};

var _default = composeHandlers;
exports["default"] = _default;